/* FIFI theme interactions: quick add, bag count, wishlist, shop the look,
   mobile menu, footer accordions. No dependencies. */
(function () {
  'use strict';

  var FIFI = window.FIFI || { routes: {}, strings: {} };
  var WISH_KEY = 'fifi:wishlist';

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(message) {
    var el = document.querySelector('.fifi-toast');
    if (!el) return;
    el.querySelector('.fifi-toast__text').textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 2200);
  }

  /* ---------- Cart ---------- */
  function setCartCount(count) {
    document.querySelectorAll('[data-fifi-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function addToCart(variantId, name, button) {
    var card = button.closest('[data-fifi-card]');
    if (card) card.classList.add('is-loading');
    button.disabled = true;

    return fetch((FIFI.routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || FIFI.strings.error);
          return data;
        });
      })
      .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        setCartCount(cart.item_count);
        toast((FIFI.strings.added || 'Added') + ' ' + name);
        document.dispatchEvent(new CustomEvent('fifi:cart-updated', { detail: cart }));
      })
      .catch(function (err) { toast(err.message || FIFI.strings.error || 'Something went wrong'); })
      .finally(function () {
        button.disabled = false;
        if (card) card.classList.remove('is-loading');
      });
  }

  FIFI.addToCart = addToCart;
  window.FIFI = FIFI;

  /* ---------- Wishlist (stored in this browser) ---------- */
  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch (e) { return []; }
  }
  function writeWishlist(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) { /* storage unavailable */ }
  }
  function renderWishlist() {
    var list = readWishlist();
    document.querySelectorAll('[data-fifi-wish]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', list.indexOf(btn.dataset.fifiWish) > -1 ? 'true' : 'false');
    });
    document.querySelectorAll('[data-fifi-wish-count]').forEach(function (el) { el.textContent = list.length; });
  }
  function toggleWish(handle) {
    var list = readWishlist();
    var i = list.indexOf(handle);
    if (i > -1) {
      list.splice(i, 1);
      toast(FIFI.strings.wishlistRemoved || 'Removed from wishlist');
    } else {
      list.push(handle);
      toast(FIFI.strings.wishlistAdded || 'Saved to wishlist');
    }
    writeWishlist(list);
    renderWishlist();
  }

  /* ---------- Mobile menu ---------- */
  function setMenu(open) {
    var menu = document.querySelector('[data-fifi-menu]');
    if (!menu) return;
    menu.hidden = !open;
    document.body.classList.toggle('fifi-menu-open', open);
    document.querySelectorAll('[data-fifi-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
    if (open) {
      var close = menu.querySelector('[data-fifi-menu-close]');
      if (close) close.focus();
    }
  }

  /* ---------- Shop the look ---------- */
  function pickLook(button) {
    var section = button.closest('[data-fifi-look]');
    if (!section) return;
    var index = button.dataset.fifiLookPick;
    section.querySelectorAll('[data-fifi-look-pick]').forEach(function (el) {
      el.classList.toggle('is-active', el.dataset.fifiLookPick === index);
    });
    section.querySelectorAll('[data-fifi-look-panel]').forEach(function (el) {
      el.hidden = el.dataset.fifiLookPanel !== index;
    });
  }

  /* ---------- Delegated clicks ---------- */
  document.addEventListener('click', function (event) {
    var target = event.target;

    var add = target.closest('[data-fifi-add]');
    if (add) {
      event.preventDefault();
      addToCart(add.dataset.fifiAdd, add.dataset.fifiName || '', add).then(function () {
        var sizes = add.closest('[data-fifi-sizes]');
        if (sizes) {
          sizes.hidden = true;
          var toggle = sizes.parentElement.querySelector('[data-fifi-size-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        }
      });
      return;
    }

    var sizeToggle = target.closest('[data-fifi-size-toggle]');
    if (sizeToggle) {
      var panel = sizeToggle.parentElement.querySelector('[data-fifi-sizes]');
      if (panel) {
        panel.hidden = !panel.hidden;
        sizeToggle.setAttribute('aria-expanded', String(!panel.hidden));
      }
      return;
    }

    var wish = target.closest('[data-fifi-wish]');
    if (wish) { toggleWish(wish.dataset.fifiWish); return; }

    var look = target.closest('[data-fifi-look-pick]');
    if (look) { pickLook(look); return; }

    if (target.closest('[data-fifi-menu-open]')) { setMenu(true); return; }
    if (target.closest('[data-fifi-menu-close]')) { setMenu(false); return; }
    if (target.closest('[data-fifi-menu] a')) { setMenu(false); }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setMenu(false);
  });

  /* ---------- Footer accordions: collapsed on mobile ---------- */
  function initFooter() {
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    document.querySelectorAll('[data-fifi-footer-col]').forEach(function (col) {
      col.open = !mobile;
    });
  }
  document.addEventListener('click', function (event) {
    var summary = event.target.closest('[data-fifi-footer-col] > summary');
    if (summary && !window.matchMedia('(max-width: 749px)').matches) event.preventDefault();
  });

  function init() {
    renderWishlist();
    initFooter();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Re-run after the theme editor re-renders a section */
  document.addEventListener('shopify:section:load', init);
})();
